import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectAccounts: {
    defaultMessage: 'Select one or more accounts',
    id: 'CheckboxSupplemental.selectAccounts',
  },
});
